import { COMPILER_ERROR_TYPES } from "@imminently/decisively-core";

export const createMissingRelationshipError = (
  received: string,
  commandName: string,
  argName: string,
  argIndex: number,
) => {
  return {
    type: COMPILER_ERROR_TYPES.MISSING_RELATIONSHIP.id,
    message: `Expected a relationship for argument ${
      argIndex + 1
    } '${argName}' of command '${commandName}', got '${received}'`,
  };
};
